import { t } from '@configuratorware/configurator-frontendgui/Framework/i18n';

export const DEFAULT_LINE_PLACEHOLDER_TEXT_KEY = 'weha.globalSettings.placeholderText';

/** Default text for a new line; call at runtime (after i18n is initialized), not at module load. */
export function getDefaultLinePlaceholderText(): string {
  return t(DEFAULT_LINE_PLACEHOLDER_TEXT_KEY);
}

export function isDefaultLinePlaceholderText(text: string | undefined | null): boolean {
  if (text == null || text === '') return false;
  return text.toUpperCase() === getDefaultLinePlaceholderText().toUpperCase();
}
